// Static JS config

import { i18n } from '/libs/i18n'

import Trix from 'trix'
Object.assign(Trix.config.lang, i18n.t('js.trix'))
import '@rails/actiontext'

//
// Custom theme for Highcharts JS
//
import Highcharts from 'highcharts'

Highcharts.theme = {
  time: { timezone: 'Europe/Paris' },
  colors: ['#e30613', '#2f5d9f', '#f28c28', '#6ba972', '#d0d7df', '#d94a4a'],
  title: {
    text: '',
    x: -20
  },
  chart: {
    zoomType: 'x',
    selectionMarkerFill: 'rgba(227, 6, 19, 0.25)'
  },
  xAxis: {
    title: {
      style: {
        color: '#e30613;'
      }
    },
    gridLineWidth: 1,
    gridLineColor: '#d4d6d9',
    step: 1
  },
  yAxis: {
    title: {
      style: {
        color: '#e30613'
      },
      margin: 20
    },
    gridLineWidth: 1,
    gridLineColor: '#d4d6d9',
    min: 0
  },
  plotOptions: {
    series: {
      animation: true
    }
  },
  legend: {
    verticalAlign: 'top',
    borderWidth: 0
  },
  credits: {
    enabled: false
  },
  lang: {
    downloadCSV: 'Télécharger CSV',
    downloadXLS: 'Télécharger XLS',
    decimalPoint: ',',
    downloadJPEG: 'Télécharger en JPEG',
    months: [
      'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ],
    shortMonths: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
    thousandsSep: ' ',
    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
  }
}

Highcharts.setOptions(Highcharts.theme);
